module.exports = __webpack_public_path__ + "img/ACTN.9c5171f8.svg";